import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  Typography, FormControl, Button, CircularProgress
} from '@mui/material';
import { Launch } from '@mui/icons-material';
import AutoComplete from '../../../../UI/Autocomplete/Autocomplete'
import * as actions from '../../../../store/actions'
import api from '../../../../axios/api';
import { i18n } from '../../../../translate/i18n';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { formatLanguageFromLocalStorage } from '../../../../utils/formatLanguageFromLocalStorage';
import moment from 'moment';

const CondensedReport = () => {
  const dispatch = useDispatch();

  const sites = useSelector(state => state.sites.allSites);
  const equipmentModels = useSelector(state => state.reports.equipmentModels);
  const loadingEquipmentModels = useSelector(state => state.reports.loadingEquipmentModels);
  const equipmentServices = useSelector(state => state.reports.equipmentModel.equipmentServices);
  const [sitesFormated, setSitesFormated] = useState([]);
  const [selectedSite, setSelectedSite] = useState({});
  const [equipmentModelsFormated, setEquipmentModelsFormated] = useState([]);
  const [selectedEquipmentModels, setSelectedEquipmentModels] = useState({});
  const [searchTextEquipmentModels, setSearchTextEquipmentModels] = useState('');
  const [equipmentModelsError, setEquipmentModelsError] = useState(false);
  const [equipmentServicesFormated, setEquipmentServicesFormated] = useState([]);
  const [selectedEquipmentService, setSelectedEquipmentService] = useState({});
  const [downloading, setDownloading] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf('month'));
	const [endDate, setEndDate] = useState(moment(new Date()));

  useEffect(() => {
    setSitesFormated(sites.rows.map((site) =>({ value: site._id, label: site.name })))
  }, [sites]);

  useEffect(() => {
    setEquipmentModelsFormated(equipmentModels.rows.map((site) =>({ value: site._id, label: site.name })))
  }, [equipmentModels])

  useEffect(() => {
    if (equipmentServices) {
      setEquipmentServicesFormated(equipmentServices.map((dt) => ({ value: dt._id, label: `${dt.serviceType ? dt.serviceType.name : ''} ${dt.frequency ? dt.frequency.name : ''}`, service_types: dt.serviceType._id  })));
    }
  }, [equipmentServices])

  useEffect(() => {
    dispatch(actions.fetchEquipmentModelsReports(searchTextEquipmentModels));
  }, [searchTextEquipmentModels]);

  const handleInputChangeEquipmentModels = (selected) => {
    setEquipmentModelsError(false);
    if (selected) {
      setSelectedEquipmentModels(selected)
      dispatch(actions.fetchEquipmentModelByIdReports(selected.value))
    } else {
      setSelectedEquipmentModels({})
      setSelectedEquipmentService({})
      dispatch(actions.clearSelectedEquipmentModelReports())
    }
  }

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const exportExcel = () => {
    setDownloading(true);

    const query = `sites=${selectedSite.value}
    &equipmentModel=${selectedEquipmentModels.value}
    &equipmentService=${selectedEquipmentService.value}
    &service_types=${selectedEquipmentService.service_types}
    ${startDate ? `&after=${startDate.toISOString()}` : ''}
    ${endDate ? `&before=${endDate.toISOString()}` : ''}
    ${emailLanguage ? `&emailLanguage=${emailLanguage}` : 'pt'}`;

    api.get(`/reports/condensedReport?${query}`)
      .then(response => {
        if (response.data) {
          window.open(response.data.url, "_blank")
        }
        setDownloading(false);
      })
      .catch(() => setDownloading(false))
  }

  const verifyStartDateRange = () => {
		if(moment(endDate) < moment(startDate)) {
			setStartDate(endDate)
		}
	}

  return (
    <div style={styles.selectsContainer}>
      <Typography style={styles.title} variant='h6'>{i18n.t('condensedReport.condensedReport')}</Typography>
      <FormControl variant="standard" fullWidth margin='normal'>
        <AutoComplete
          loading={false} //sent to isLoading
          label={i18n.t('condensedReport.sites')}
          data={sitesFormated} // sent to options
          onSelectValue={(value) => setSelectedSite(value)} // sent to onChange
          valueSelected={selectedSite} // sent to value
          newSearchText={() => {}}
          isMulti={false}
          name='sitesReports'
          hasError={false}
          disabled={false}
        />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal'>
        <AutoComplete
          loading={loadingEquipmentModels} // sent to isLoading
          label={i18n.t('condensedReport.equipmentModels')}
          data={equipmentModelsFormated} // sent to options
          onSelectValue={handleInputChangeEquipmentModels} // sent to onChange
          valueSelected={selectedEquipmentModels} // sent to value
          newSearchText={(text) => setSearchTextEquipmentModels(text)}
          name='equipmentModelsReports'
          hasError={equipmentModelsError}
          disabled={false}
        />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal'>
        <AutoComplete
          label={i18n.t('condensedReport.equipmentServices')}
          data={equipmentServicesFormated} // sent to options
          onSelectValue={(value) => setSelectedEquipmentService(value)} // sent to onChange
          valueSelected={selectedEquipmentService} // sent to value
          newSearchText={() => {}}
          name='serviceTypesReports'
          hasError={false}
          disabled={isEmpty(selectedEquipmentModels)}
        />
      </FormControl>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <FormControl variant="standard" margin='normal' style={{ marginRight: '150px'}}>
            <DatePicker
              label={i18n.t('condensedReport.from')}
              margin='normal'
              value={startDate && new Date(startDate)}
              onChange={date => setStartDate(date ? date : null)}
              format="dd/MM/yyyy"
              slotProps={{ textField: { variant: 'standard', } }}
              />
          </FormControl>
          <FormControl variant="standard" margin='normal' style={{ marginLeft: '150px'}}>
            <DatePicker
              label={i18n.t('condensedReport.to')}
              margin='normal'
              value={endDate && new Date(endDate)}
              onChange={date => setEndDate(date ? date : null)}
              onBlurCapture={verifyStartDateRange}
              format="dd/MM/yyyy"
              slotProps={{ textField: { variant: 'standard', } }}
              />
          </FormControl>
      </div>
      <div style={styles.buttonContainer}>
        <Button
          variant='outlined'
          aria-label="add"
          style={styles.button}
          onClick={exportExcel}
          disabled={isEmpty(selectedEquipmentModels) || isEmpty(selectedSite) || isEmpty(selectedEquipmentService) || !startDate || !endDate}
          startIcon={downloading ? <CircularProgress size={14} style={{ color: 'green' }} /> : <Launch style={styles.icon} />}
        >
          {i18n.t('condensedReport.buttonText')}
        </Button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
  },
  title: {
    margin: 0
  },
  selectsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: 0,
    padding: '10px 20px',
    width: '100%',
  },
  buttonContainer: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width : '40%',
  },
  tableTitleContainer: {
    position: 'relative',
  },
  button: {
		// marginLeft: '0.5rem',
    textAlign: 'center',
    marginBottom: '10px',
    padding: '15px',
	},
}

export default CondensedReport;